
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy/ebuy",
      function () {
        return require("private-next-pages/privacy/ebuy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy/ebuy"])
      });
    }
  